import Resolution from 'engine/Resolution.js';
const baseResolution = new Resolution(32, false);

export const getStepsInSelection = ({
    pattern,
    selection,
    resolution,
    checkIntersection=false
}) => {
    let start = baseResolution.transformStepAtResolution2(
        selection.stepNumber,
        resolution);
    let end = baseResolution.transformStepAtResolution2(
        selection.stepNumber + selection.numSteps,
        resolution);

    // there are 3 cases

    let stepsFound = [];

    // case 1: any preceeding steps that extend into and intersect the start position
    stepsFound = [
        ... stepsFound,
        ... findIntersectingBefore(pattern, start)
    ];

    // case 2: any steps between start AND ceil(start);
    stepsFound = [
        ... stepsFound,
        ... findAfter(pattern, Math.floor(start), start - Math.floor(start))
    ];

    // case 3: go step by step
    for (let i=Math.ceil(start); i < Math.floor(end); i++) {
        let bucket = pattern.stepBuckets[i];
        stepsFound = [
            ... stepsFound,
            ... bucket.getAllOnSteps(),
        ];
    }

    // case 4: steps between floor(end) AND end
    // case 2: any steps between start AND ceil(start);
    stepsFound = [
        ... stepsFound,
        ... findBefore(pattern, Math.floor(end), end - Math.floor(end))
    ];

    return Array.from(new Set(stepsFound)).filter(
        step => isStepSelected(step, selection));
};

const findIntersectingBefore = (pattern, stepNumber) => {
    let steps = [];
    for (let i=Math.floor(stepNumber); i >= 0; i--) {
        let currentSteps = pattern.getAllOnStepAtResolutionAtAnyPosition(
            i, baseResolution);
        for (let step of currentSteps) {
            let duration = step.duration * 2;
            if (i + duration > stepNumber) {
                steps.push(step);
            }
        }
    }
    return steps;
};

const findAfter = (pattern, stepNumber, position) => {
    let steps = [];
    let bucket = pattern.stepBuckets[stepNumber];
    for (let _position in bucket.steps) {
        if (parseFloat(_position) >= position) {
            steps = [
                ... steps,
                ... bucket.steps[_position].getPolyphony()
                    .filter(x => x.on)
                    
            ];
        }
    }
    return steps;
};

const findBefore = (pattern, stepNumber, position) => {
    let steps = [];
    let bucket = pattern.stepBuckets[stepNumber];
    for (let _position in bucket.steps) {
        if (parseFloat(_position) <= position) {
            steps = [
                ... steps,
                ... bucket.steps[_position].getPolyphony()
                    .filter(x => x.on)
            ];
        }
    }
    return steps;
};

const  isStepSelected = (step, selection) => {
    let transpose = step.transpose === null ?
        this.trackData.transpose : step.transpose;
    return transpose <= selection.transpose &&
        transpose > selection.transpose - selection.numNotes;
};
 
